<template>
  <div class="loader-container" align="center">
    <a class="loader is-loading"></a>
  </div>  
</template>
<style lang="sass" scoped>
@import "@/assets/sass/main.sass"

.loader-container
  opacity: 0.3

@-webkit-keyframes spinAround
  from
    -webkit-transform: rotate(0deg)
    transform: rotate(0deg)
  to 
    -webkit-transform: rotate(359deg)
    transform: rotate(359deg)

@keyframes spinAround 
  from
    -webkit-transform: rotate(0deg)
    transform: rotate(0deg)
  to 
    -webkit-transform: rotate(359deg)
    transform: rotate(359deg)

.loader
    -moz-appearance: none
    -webkit-appearance: none
    align-items: center
    border: 1px solid transparent
    border-radius: 4px
    box-shadow: none
    display: inline-flex
    font-size: 10rem
    height: 50vh
    justify-content: flex-start
    line-height: 1.5
    padding-bottom: calc(0.375em - 1px)
    padding-left: calc(0.625em - 1px)
    padding-right: calc(0.625em - 1px)
    padding-top: calc(0.375em - 1px)
    position: relative
    vertical-align: top

.loader.is-loading::after
    -webkit-animation: spinAround 10000ms infinite linear
    animation: spinAround 10000ms infinite linear
    border: 4px solid $primary
    border-radius: 290486px
    border-right-color: transparent
    border-top-color: transparent
    content: ""
    display: block
    height: 1em
    position: relative
    width: 1em

.loader.is-loading
  color: transparent !important
  pointer-events: none

.loader.is-loading::after
  position: absolute
  left: calc(50% - (1em / 2))
  top: calc(50% - (1em / 2))
  position: absolute !important

</style>